export class CampaignModel {
    id!: number;
    name!: string;
    created_at!: string;
    file!: string;
    file_name!: string;
    active!: number;
    id_company!: number;
    id_nest!: number;
}

export class FileModel {
    id!: string;
    name!: string;
    created_at!: string;
}

export class PendingBoxes {
    zona!:         string;
    sucursal!:     string;
    paqueteria!:   string;
    guia!:         string;
    estatus!:      string;
    lastUpdate!:  string;
}

export class CampaignTrackingModel {
    guia!: string;
    fecha_entrega!: string;
    recibio!: string;
    estatus!: string;
    last_update!: string;
    zona!: string;
    sucursal!: string;
    direccion!: string;
    coords!: string;
}

export class BranchModel {
    id!: number;
    id_compania!: number;
    compania!: string;
    id_zona!: number;
    zona!: string;
    nombre!: string;
    filial!: string;
    farm_id!: string;
    estafeta!: string;
    shipping_type!: number;
}

export class CampaignModelPNP {
    id!: number;
    name!: string;
    created_at!: string;
    total_boxes!: number;
    start_boxes!: number;
    ended_boxes!: number;
    rest_boxes!: number;
    materials!: number;
    taped_perc!:number;
    status!: string;
}

export class BoxModelPNP {
    id!: number;
    consecutivo!: number;
    zona!: string;
    sucursal!: string;
    entro_linea!: string;
    video!: string;
}

export class MaterialsModelPNP {
    id!: number;
    nombre!: string;
    cantidad!: number;
    sku!: string;
    packed!: number;
    omitted!: number;
    missed!: number;
}

/** Represents the data that the selectors can use for the bulk-upload table. @interface */
export interface SDSelectorData {
    carrDepn: Array<Array<string>>;
    carriers: Array<string>;
    providers: Array<string>;
    servDepn: Array<Array<Array<string>>>;
    services: Array<string>;
}

/** Represents the data that will be shown in a card of the bulk-upload showcase. @interface */
export interface SDShowcaseEntry {
    data: Array<{ name: string, qty: number }>;
    provider: string;
    qty: number;
}

/** A catalog used to normalize raw carrier and service values from maps. */
export class Catalog {
    /** The carriers' dictionary. */
    public carriers: { [raw: string]: string } = {};
    /** The services' dictionaty. */
    public services: { [raw: string]: 'Aéreo' | 'Aereo' | 'Terrestre' | '' } = {};

    /** Creates a new Catalog instance.
      * @param {any} tabledata - The raw data as it comes from the DB.
      * @param {boolean} abbreviated - `true` if the normalized carriers' names must be abbreviated. Defaults to `false`. */
    constructor(tabledata: any, abbreviated: boolean = false) {
        for (const x of tabledata) {
            let carr: string = x.carrier_name?.trim();
            const rawc: string = x.carrier?.trim(),
                  raws: string = x.service?.trim(),
                  serv: string = x.service_mode?.trim();

            // Capitalize carrier
            carr = carr.charAt(0).toUpperCase() + carr.slice(1);

            // Abbreviate names if requested
            if (abbreviated) {
                switch (carr[0].toLocaleLowerCase()) {
                    case '9': carr = '99M'; break;
                    case 'b': carr[1] == 'i' ? carr = 'Big' : carr; break;
                    case 'j': carr = 'J&T'; break;
                    case 'p': carr = 'PEX'; break;
                }
            }

            // Create dictionary entry for carrier
            if (carr && rawc)
                this.carriers[rawc] = carr;

            // Create dictionary entry for service
            if (raws && serv)
                this.services[raws] = (serv[0].toLocaleLowerCase() === 'a') ? 'Aéreo' : 'Terrestre';
        }
    }

    /** Normalizes a carrier's name.
      * @param {string} name - The carrier's name
      * @returns {string} Standard carrier name if found, otherwise, the same input. */
    normalizeCarrier(name: string): string {
        return this.carriers[name] || name;
    }

    /** Normalizes a service's name.
      * @param {string} name - The service's name
      * @returns {'Aéreo' | 'Terrestre'} Standard service name if found, otherwise, the same input. */
    normalizeService(name: string): 'Aéreo' | 'Aereo' | 'Terrestre' | '' {
        let x: 'Aéreo' | 'Terrestre' | '' = '';

        if (name.toLocaleLowerCase() == 'aéreo' || name.toLocaleLowerCase() == 'aereo' || name.toLocaleLowerCase() == 'terrestre')
            x = (name[0] === 'a') ? 'Aéreo' : 'Terrestre';
        else x = '';

        return this.services[x] || x;
    }
}